const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

function revealOnScroll() {
  const items = document.querySelectorAll('[data-about-reveal], .about-reveal-item');

  if (!items.length) return;

  if (reducedMotion || !('IntersectionObserver' in window)) {
    items.forEach((item) => item.classList.add('is-visible'));
    return;
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    {
      threshold: 0.16,
      rootMargin: '0px 0px -10% 0px',
    }
  );

  items.forEach((item) => observer.observe(item));
}

function parallaxOnScroll() {
  if (reducedMotion) return;

  const scenes = [...document.querySelectorAll('[data-about-parallax]')];
  if (!scenes.length) return;

  let ticking = false;

  const update = () => {
    const viewportHeight = window.innerHeight;

    scenes.forEach((scene) => {
      const strength = Number(scene.style.getPropertyValue('--about-parallax-strength')) || 0.12;
      const media = scene.querySelector('.about-hero__image, .about-image-banner__image');
      if (!media) return;

      const rect = scene.getBoundingClientRect();
      const progress = (viewportHeight - rect.top) / viewportHeight;
      const translateY = Math.max(-24, Math.min(120, progress * strength * 260));
      media.style.setProperty('--about-parallax-offset', `${translateY}px`);
    });

    ticking = false;
  };

  const onScroll = () => {
    if (!ticking) {
      window.requestAnimationFrame(update);
      ticking = true;
    }
  };

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  update();
}

function quoteWordHighlight() {
  const sections = [...document.querySelectorAll('.about-quote-banner [data-quote-words]')];
  if (!sections.length) return;

  const setActiveCount = (container, count) => {
    const words = [...container.querySelectorAll('[data-quote-word]')];
    const safeCount = Math.max(0, Math.min(count, words.length));

    words.forEach((word, index) => {
      word.classList.toggle('is-highlight', index < safeCount);
      word.classList.toggle('is-active', index === safeCount - 1 || (safeCount === words.length && index === words.length - 1));
    });
  };

  if (reducedMotion || !('IntersectionObserver' in window)) {
    sections.forEach((section) => setActiveCount(section, section.querySelectorAll('[data-quote-word]').length));
    return;
  }

  const update = (container) => {
    const section = container.closest('.about-quote-banner');
    if (!section) return;

    const rect = section.getBoundingClientRect();
    const viewport = window.innerHeight || document.documentElement.clientHeight;
    const progress = 1 - Math.min(1, Math.max(0, rect.bottom / (viewport + rect.height)));
    const words = container.querySelectorAll('[data-quote-word]');
    const count = Math.ceil(progress * words.length);
    setActiveCount(container, count);
  };

  let ticking = false;
  const onScroll = () => {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(() => {
      sections.forEach(update);
      ticking = false;
    });
  };

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  onScroll();
}

document.addEventListener('DOMContentLoaded', () => {
  revealOnScroll();
  parallaxOnScroll();
  quoteWordHighlight();
});
